<app-timeline-workshop-defect-information [defect]='this.currentDefect'></app-timeline-workshop-defect-information>
<div class='acceptedDefectsContainer'>
  <div class='header'>
    <i class="fa-exclamation-triangle fas"></i> Defects &nbsp;&nbsp;<button class='btn btn-secondary btn-small' (click)='this.loadDefects()'><i class="fas fa-sync-alt"></i></button>
  </div>

  <div class="bodyContainer">

    <input type='text' placeholder='🔍 Search...' class='form-control' [(ngModel)]="this.search" (keyup)='this.loadDefects()'/>

    <div class="form-group">
      <label for="inputPassword4">Sort by</label>
      <select class='form-control' (change)='this.sortBy = $event.target.value; this.loadDefects()'>
        <option value='bookingFor'>Booked For</option>
        <option value='vehicleCheckArea'>Vehicle check area</option>
        <option value='inspectionType'>Inspection type</option>
      </select>
    </div>

    @if (this.defects.length > 0) {
      @for (defect of this.defects; track defect) {
        <div
          [class.dragging]='this.draggingId == defect.id'
          data-id='{{ defect.id }}'
          draggable="true"
          (dragstart)='dragStart($event, defect)'
          (dragend)='dragEnd($event)'
          [class.isVOR]='defect.vehicleSeverity.isVor'
          class='defectContainer'
          data-id='{{ defect.id }}'
          draggable="true">
          <button class='btn btn-secondary btn-small' (click)='this.currentDefect = defect; openModal("defectInformationModal")'><i class="fas fa-info-circle"></i></button>&nbsp;&nbsp;<strong>{{ defect.vehicle.registration }}</strong>/{{ defect.vehicleCheckArea.name }}/{{ defect.description }}<br />
        </div>
      }
    }
    @if (this.defects.length === 0) {
      <div style='color:red;font-weight:bold'>No results found</div>
    }
  </div>
</div>
